import { type FC } from 'react';
import { faBox } from '@fortawesome/pro-light-svg-icons';
import InfoPill from '../InfoPill/InfoPill';

export interface ShippingInfoProps {
  unitsPerCase?: number | null;
  unitsPerPallet?: number | null;
  compact?: boolean;
  hideIcons?: boolean;
}

const ShippingInfo: FC<ShippingInfoProps> = ({
  unitsPerCase,
  unitsPerPallet,
  compact = false,
  hideIcons = false,
}) => {
  if (!unitsPerCase && !unitsPerPallet) return null;

  return unitsPerCase && unitsPerCase > 0 ? (
    <InfoPill
      icon={faBox}
      value={unitsPerCase}
      tooltip="Units per Case"
      compact={compact}
      hideIcon={hideIcons}
    />
  ) : null;
};

export default ShippingInfo;
